class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

// Department bar (sections/header-departments.liquid): click and Enter toggle the
// details natively, mouse users also get hover, one panel open at a time.
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.addEventListener('pointerenter', this.onPointer.bind(this, true));
    this.addEventListener('pointerleave', this.onPointer.bind(this, false));
  }

  onPointer(enter, event) {
    if (event.pointerType !== 'mouse') return;
    if (enter) this.mainDetailsToggle.setAttribute('open', '');
    else if (!this.contains(document.activeElement) || document.activeElement === this.summary) this.close();
  }

  onToggle() {
    super.onToggle();
    const isOpen = this.mainDetailsToggle.open;
    this.summary.setAttribute('aria-expanded', isOpen);
    if (isOpen) document.querySelectorAll('header-menu').forEach((menu) => menu !== this && menu.close());
  }
}

customElements.define('header-menu', HeaderMenu);
